(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-announcements"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sr-announcement-marquee')) {
    class SrAnnouncementMarquee extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.sr-ann-marquee__track');
        this.group = this.querySelector('.sr-ann-marquee__group');
        if (!this.track || !this.group) return;
        this.groupWidth = 0;
        this.copies = 0;
        this.resizeObserver = new ResizeObserver(() => this.build());
        this.resizeObserver.observe(this);
        this.resizeObserver.observe(this.group);
        this.build();
      }

      disconnectedCallback() {
        if (this.resizeObserver) this.resizeObserver.disconnect();
      }

      build() {
        const groupWidth = this.group.getBoundingClientRect().width;
        const width = this.getBoundingClientRect().width;
        if (!groupWidth || !width) return;

        const copies = Math.ceil(width / groupWidth) + 1;
        if (Math.abs(groupWidth - this.groupWidth) < 0.5 && copies === this.copies) return;
        this.groupWidth = groupWidth;
        this.copies = copies;

        this.track.querySelectorAll('[data-sr-ann-clone]').forEach((clone) => clone.remove());
        for (let i = 1; i < copies; i++) {
          const clone = this.group.cloneNode(true);
          clone.setAttribute('data-sr-ann-clone', '');
          clone.setAttribute('aria-hidden', 'true');
          clone.inert = true;
          clone.querySelectorAll('[data-shopify-editor-block]').forEach((node) => {
            node.removeAttribute('data-shopify-editor-block');
          });
          this.track.append(clone);
        }

        const speed = Number(this.dataset.speed) || 50;
        this.style.setProperty('--sr-ann-distance', groupWidth + 'px');
        this.style.setProperty('--sr-ann-duration', (groupWidth / speed).toFixed(2) + 's');

        this.classList.remove('is-ready');
        void this.track.offsetWidth;
        this.classList.add('is-ready');
      }
    }

    customElements.define('sr-announcement-marquee', SrAnnouncementMarquee);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sr-collection-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initListing(root) {
      if (!root || root.dataset.srlBound === 'true') return;
      root.dataset.srlBound = 'true';

      var openBtn = root.querySelector('[data-srl-open]');
      var panel = root.querySelector('[data-srl-panel]');
      var mobileQuery = window.matchMedia('(max-width: 989px)');

      function setOpen(open) {
        if (!panel) return;
        var wasOpen = root.classList.contains('is-filters-open');
        root.classList.toggle('is-filters-open', open);
        document.documentElement.classList.toggle('srl-lock', open);
        if (openBtn) openBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) {
          var closeBtn = panel.querySelector('.srl__panel-close');
          if (closeBtn) closeBtn.focus({ preventScroll: true });
        } else if (wasOpen && openBtn) {
          openBtn.focus({ preventScroll: true });
        }
      }

      if (openBtn) {
        openBtn.addEventListener('click', function () {
          setOpen(true);
        });
      }

      root.querySelectorAll('[data-srl-close]').forEach(function (el) {
        el.addEventListener('click', function () {
          setOpen(false);
        });
      });

      root.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && root.classList.contains('is-filters-open')) setOpen(false);
      });

      if (mobileQuery.addEventListener) {
        mobileQuery.addEventListener('change', function (event) {
          if (!event.matches) setOpen(false);
        });
      }

      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      root.querySelectorAll('[data-srl-season-track]').forEach(function (seasonTrack) {
        var seasonOptions = seasonTrack.querySelectorAll('[data-srl-season-option]');
        var seasonScroll = seasonTrack.parentElement;
        var seasonActive = seasonTrack.querySelector('.srl__season-option.is-active');
        if (seasonActive && seasonScroll && seasonScroll.scrollWidth > seasonScroll.clientWidth) {
          seasonScroll.scrollLeft = seasonActive.offsetLeft - (seasonScroll.clientWidth - seasonActive.offsetWidth) / 2;
        }

        seasonOptions.forEach(function (option) {
          option.addEventListener('click', function (event) {
            if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
            event.preventDefault();
            if (option.classList.contains('is-active')) return;

            seasonTrack.style.setProperty('--srl-season-index', option.dataset.index);
            seasonTrack.style.setProperty('--srl-season-color', option.dataset.color);
            seasonTrack.style.setProperty('--srl-season-text', option.dataset.text);
            seasonTrack.classList.add('has-active');
            seasonOptions.forEach(function (item) {
              item.classList.toggle('is-active', item === option);
              if (item === option) {
                item.setAttribute('aria-current', 'true');
              } else {
                item.removeAttribute('aria-current');
              }
            });

            var href = option.href;
            window.setTimeout(function () {
              window.location.href = href;
            }, reduceMotion ? 0 : 420);
          });
        });
      });

      if (mobileQuery.matches) {
        root.querySelectorAll('[data-srl-group]').forEach(function (group) {
          if (group.dataset.srlActive !== 'true') group.open = false;
        });
      }

      root.querySelectorAll('[data-srl-sort]').forEach(function (select) {
        select.addEventListener('change', function () {
          var url = new URL(window.location.href);
          url.searchParams.set('sort_by', select.value);
          url.searchParams.delete('page');
          url.searchParams.set('filter.v.availability', '1');
          window.location.href = url.toString();
        });
      });

      root.querySelectorAll('[data-srl-search]').forEach(function (form) {
        form.addEventListener('submit', function () {
          var input = form.querySelector('input[name="q"]');
          var tags = form.dataset.srlTags || '';
          if (input && tags) input.value = (tags + ' ' + input.value).trim();
        });
      });
    }

    function initAll() {
      document.querySelectorAll('[data-srl]').forEach(initListing);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sr-popup-descuento"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('sr-popup-descuento')) return;

    var KEY = 'srPopupDescuento';

    class SrPopupDescuento extends HTMLElement {
      connectedCallback() {
        if (this.bound) return;
        this.bound = true;

        this.designMode = !!(window.Shopify && window.Shopify.designMode);
        this.days = parseInt(this.dataset.days, 10) || 14;
        this.form = this.querySelector('.srpd__form');
        this.email = this.querySelector('[data-srpd-email]');
        this.errorEl = this.querySelector('[data-srpd-error]');

        this.addEventListener('click', this.onClick.bind(this));
        document.addEventListener('keydown', this.onKey.bind(this));
        document.addEventListener('shopify:cart:lines-update', this.close.bind(this));
        if (this.form) this.form.addEventListener('submit', this.onSubmit.bind(this));

        if (this.designMode) {
          this.open();
          return;
        }

        if (this.querySelector('[data-srpd-posted]')) {
          this.done = true;
          this.remember('done');
          this.open();
          this.screen(3);
          return;
        }

        if (this.errorEl && !this.errorEl.hidden) {
          this.open();
          this.screen(2);
          return;
        }

        if (this.seen()) return;

        var delay = (parseInt(this.dataset.delay, 10) || 0) * 1000;
        if (delay > 0) this.timer = window.setTimeout(this.open.bind(this), delay);

        if (this.dataset.exit === '1') {
          this.onLeave = function (event) {
            if (event.clientY > 0) return;
            this.open();
          }.bind(this);
          document.addEventListener('mouseout', this.onLeave);
        }
      }

      seen() {
        try {
          if (window.sessionStorage.getItem(KEY) === 'shown') return true;
        } catch (error) {}

        try {
          var raw = window.localStorage.getItem(KEY);
          if (!raw) return false;
          var data = JSON.parse(raw);
          if (data.state === 'done') return true;
          return Date.now() - (data.t || 0) < this.days * 864e5;
        } catch (error) {
          return false;
        }
      }

      markSession() {
        if (this.designMode) return;
        try {
          window.sessionStorage.setItem(KEY, 'shown');
        } catch (error) {}
      }

      remember(state) {
        if (this.designMode) return;
        try {
          window.localStorage.setItem(KEY, JSON.stringify({ state: state, t: Date.now() }));
        } catch (error) {}
      }

      open() {
        if (this.hidden === false) return;
        if (!this.designMode && document.querySelector('dialog[open]')) return;
        this.markSession();
        this.hidden = false;
        document.documentElement.style.overflow = 'hidden';
        if (this.timer) window.clearTimeout(this.timer);
        if (this.onLeave) document.removeEventListener('mouseout', this.onLeave);
      }

      close() {
        this.hidden = true;
        document.documentElement.style.overflow = '';
        if (this.timer) window.clearTimeout(this.timer);
        if (this.onLeave) document.removeEventListener('mouseout', this.onLeave);
        if (!this.done) this.remember('closed');
      }

      onKey(event) {
        if (event.key === 'Escape' && !this.hidden) this.close();
      }

      screen(number) {
        this.querySelectorAll('[data-srpd-screen]').forEach(function (screen) {
          screen.hidden = screen.dataset.srpdScreen !== String(number);
        });
      }

      showError(message) {
        if (!this.errorEl) return;
        this.errorEl.textContent = message || '';
        this.errorEl.hidden = !message;
      }

      onClick(event) {
        var target = event.target;
        if (!target.closest) return;

        if (target.closest('[data-srpd-close]')) {
          event.preventDefault();
          this.close();
          return;
        }

        if (target.closest('[data-srpd-next]')) {
          event.preventDefault();
          this.screen(2);
          if (this.email) this.email.focus();
          return;
        }

        var use = target.closest('[data-srpd-use]');
        if (use) {
          event.preventDefault();
          this.apply(use);
          return;
        }
      }

      apply(button) {
        if (button.getAttribute('aria-busy') === 'true') return;

        var self = this;
        var code = button.dataset.code || '';
        this.done = true;
        this.remember('done');
        button.setAttribute('aria-busy', 'true');

        var request = code
          ? fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin', redirect: 'manual' })
          : Promise.resolve();

        request
          .catch(function () {})
          .then(function () {
            button.removeAttribute('aria-busy');
            if (self.dataset.appliedText) button.textContent = self.dataset.appliedText;
            window.setTimeout(function () {
              self.close();
            }, 900);
          });
      }

      onSubmit(event) {
        var value = (this.email && this.email.value ? this.email.value : '').trim();
        if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(value)) {
          event.preventDefault();
          this.showError(this.dataset.error);
          if (this.email) this.email.focus();
          return;
        }

        this.showError('');
        this.done = true;
        this.remember('done');
      }
    }

    customElements.define('sr-popup-descuento', SrPopupDescuento);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sr-search-modal"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__srsSearchInit) return;
    window.__srsSearchInit = true;

    var DEBOUNCE = 260;
    var STORAGE_KEY = 'ccv:recently-viewed';

    function makeMoneyFormatter(moneyFormat) {
      return function (cents) {
        if (typeof cents === 'string') cents = cents.replace('.', '');
        function fmt(num, precision, thousands, decimal) {
          if (isNaN(num) || num == null) return '0';
          var n = (Math.abs(Number(num)) / 100).toFixed(precision);
          var parts = n.split('.');
          var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
          return dollars + (parts[1] ? decimal + parts[1] : '');
        }
        var re = /\{\{\s*(\w+)\s*\}\}/;
        var m = moneyFormat.match(re);
        var key = m ? m[1] : 'amount';
        var val;
        switch (key) {
          case 'amount_no_decimals': val = fmt(cents, 0, ',', '.'); break;
          case 'amount_with_comma_separator': val = fmt(cents, 2, '.', ','); break;
          case 'amount_no_decimals_with_comma_separator': val = fmt(cents, 0, '.', ','); break;
          case 'amount_with_space_separator': val = fmt(cents, 2, ' ', ','); break;
          case 'amount_no_decimals_with_space_separator': val = fmt(cents, 0, ' ', ''); break;
          case 'amount_with_apostrophe_separator': val = fmt(cents, 2, "'", '.'); break;
          default: val = fmt(cents, 2, ',', '.');
        }
        return moneyFormat.replace(re, val);
      };
    }

    function esc(str) {
      return String(str == null ? '' : str)
        .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
    }

    function getDialog() { return document.getElementById('srs-dialog'); }
    function openModal() {
      var d = getDialog();
      if (!d) return;
      if (typeof d.showModal === 'function') { if (!d.open) d.showModal(); }
      else d.setAttribute('open', '');
      var input = d.querySelector('[data-srs-input]');
      if (input) setTimeout(function () { input.focus(); }, 30);
    }
    function closeModal() {
      var d = getDialog();
      if (!d) return;
      if (typeof d.close === 'function' && d.open) d.close();
      else d.removeAttribute('open');
    }

    var NATIVE_SEL = '[on\\:click="#search-modal/showDialog"]';
    function bindNativeTrigger(btn) {
      if (!btn || btn.__srsBound) return;
      btn.__srsBound = true;
      btn.removeAttribute('on:click');
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        openModal();
      });
    }
    function neutralize() { document.querySelectorAll(NATIVE_SEL).forEach(bindNativeTrigger); }
    neutralize();
    document.addEventListener('DOMContentLoaded', neutralize);
    setTimeout(neutralize, 1200);
    document.addEventListener('shopify:section:load', function () { neutralize(); bindInstances(); });
    document.addEventListener('shopify:section:select', neutralize);

    function readRecent() {
      try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || []; } catch (e) { return []; }
    }

    function addSelectedToCart(root, variantId, btn) {
      if (!variantId) return;
      var original = btn.textContent;
      btn.disabled = true;

      if (!window.SRCart) {
        btn.textContent = 'Error';
        setTimeout(function () { btn.textContent = original; btn.disabled = false; }, 1500);
        return;
      }

      window.SRCart
        .add([{ id: variantId, quantity: 1 }], { source: root, sourceId: 'srs-search' })
        .then(function () {
          btn.textContent = 'Agregado ✓';
          window.SRCart.openDrawer();
          setTimeout(closeModal, 250);
        })
        .catch(function () {
          btn.textContent = 'Error';
          setTimeout(function () { btn.textContent = original; btn.disabled = false; }, 1500);
        });
    }

    function buildCard(root, p) {
      var btnLabel = root.getAttribute('data-btn-label') || 'Añadir al carrito';
      var soldOut = root.getAttribute('data-sold-out') || 'Agotado';
      var money = makeMoneyFormatter(root.getAttribute('data-money-format') || ('$' + '{' + '{amount}' + '}'));

      var variants = p.variants || [];
      var firstAvail = variants.filter(function (v) { return v.available; })[0];
      var current = firstAvail || variants[0];
      var hasChoice = variants.length > 1 || (variants[0] && !/^default title$/i.test(variants[0].title));
      var showSelect = !!firstAvail && hasChoice;

      var card = document.createElement('div');
      card.className = 'srs-card';

      var imgUrl = p.featured_image || (p.images && p.images[0]) || '';
      var mediaImg = imgUrl
        ? '<img class="srs-card__img" src="' + esc(imgUrl) + '" alt="' + esc(p.title) + '" loading="lazy">'
        : '<div class="srs-card__img"></div>';
      var badge = firstAvail ? '' : '<span class="srs-card__badge">' + esc(soldOut) + '</span>';

      var formats = variants.map(function (v) {
        var pressed = !!firstAvail && v.id === firstAvail.id;
        return '<button type="button" class="srs-card__format" data-variant-id="' + v.id + '"' +
          ' aria-pressed="' + (pressed ? 'true' : 'false') + '"' +
          ' aria-label="' + esc(v.title) + (v.available ? '' : ' - ' + esc(soldOut)) + '"' +
          (v.available ? '' : ' disabled') + '>' + esc(v.title) + '</button>';
      }).join('');

      card.innerHTML =
        '<a class="srs-card__media" href="' + esc(p.url) + '" aria-label="' + esc(p.title) + '">' + mediaImg + badge + '</a>' +
        '<div class="srs-card__info">' +
          '<a class="srs-card__name" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
          '<div class="srs-card__price">' + money(current ? current.price : p.price_min) + '</div>' +
          '<div class="srs-card__actions">' +
            (showSelect ? '<div class="srs-card__formats" role="group" aria-label="Formato">' + formats + '</div>' : '') +
            '<button type="button" class="srs-card__btn"' + (firstAvail ? '' : ' disabled') + '>' + esc(firstAvail ? btnLabel : soldOut) + '</button>' +
          '</div>' +
        '</div>';

      var btn = card.querySelector('.srs-card__btn');
      var price = card.querySelector('.srs-card__price');
      var selectedId = firstAvail ? String(firstAvail.id) : null;
      var chips = card.querySelectorAll('.srs-card__format');

      chips.forEach(function (chip) {
        chip.addEventListener('click', function () {
          if (chip.disabled) return;
          selectedId = chip.getAttribute('data-variant-id');
          chips.forEach(function (other) {
            other.setAttribute('aria-pressed', other === chip ? 'true' : 'false');
          });
          var chosen = variants.filter(function (v) { return String(v.id) === selectedId; })[0];
          if (chosen) price.textContent = money(chosen.price);
        });
      });

      if (firstAvail) {
        btn.addEventListener('click', function () { addSelectedToCart(root, selectedId, btn); });
      }
      return card;
    }

    function fillTrending(root) {
      if (root.__srsFilled) return;
      var wrap = root.querySelector('[data-srs-trending]');
      var grid = root.querySelector('[data-srs-grid]');
      if (!wrap || !grid) return;

      var rvLimit = parseInt(root.getAttribute('data-rv-limit'), 10) || 8;
      var handles = readRecent().filter(Boolean).slice(0, rvLimit);

      if (!handles.length) { wrap.hidden = true; root.__srsFilled = true; return; }

      Promise.all(handles.map(function (h) {
        return fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
      })).then(function (products) {
        var valid = products.filter(function (p) { return p && p.available && p.variants && p.variants.length; });
        root.__srsFilled = true;
        if (!valid.length) { wrap.hidden = true; return; }
        grid.innerHTML = '';
        valid.forEach(function (p) { grid.appendChild(buildCard(root, p)); });
        var input = root.querySelector('[data-srs-input]');
        wrap.hidden = !!(input && input.value.trim().length >= 2);
      });
    }

    var productCache = {};
    function fetchProduct(handle) {
      if (productCache[handle]) return productCache[handle];
      var pr = fetch('/products/' + handle + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
      productCache[handle] = pr;
      return pr;
    }

    function setFooter(root, show, term) {
      var footer = root.querySelector('[data-srs-footer]');
      var va = root.querySelector('[data-srs-viewall]');
      if (!footer) return;
      if (show && va) {
        var searchUrl = root.getAttribute('data-search-url') || '/search';
        va.href = searchUrl + '?q=' + encodeURIComponent(term) + '&type=product&filter.v.availability=1';
      }
      footer.hidden = !show;
    }

    function statusHtml(title, text, loading) {
      return '<div class="srs__status">' +
        (loading ? '<span class="srs__spinner" aria-hidden="true"></span>' : '') +
        (title ? '<p class="srs__status-title">' + title + '</p>' : '') +
        (text ? '<p class="srs__status-text">' + text + '</p>' : '') +
      '</div>';
    }

    function renderResults(root, products, term) {
      var box = root.querySelector('[data-srs-results]');
      if (!box) return;
      box.innerHTML = '<p class="srs__block-title">Resultados para “' + esc(term) + '”</p>';
      var grid = document.createElement('div');
      grid.className = 'srs__grid';
      products.forEach(function (p) { if (p) grid.appendChild(buildCard(root, p)); });
      box.appendChild(grid);
      setFooter(root, true, term);
    }

    function trendingHasCards(root) {
      var grid = root.querySelector('[data-srs-grid]');
      return !!(grid && grid.children.length);
    }

    function showTrending(root, show) {
      var trending = root.querySelector('[data-srs-trending]');
      var suggest = root.querySelector('[data-srs-suggest]');
      var results = root.querySelector('[data-srs-results]');
      if (trending) trending.hidden = !(show && trendingHasCards(root));
      if (suggest) suggest.hidden = !show;
      if (results) results.hidden = show;
      if (show) setFooter(root, false);
    }

    function doSearch(root, term) {
      var limit = parseInt(root.getAttribute('data-limit'), 10) || 8;
      var noResults = root.getAttribute('data-no-results') || 'Sin resultados para';
      var box = root.querySelector('[data-srs-results]');
      var emptyHtml = statusHtml(esc(noResults) + ' “' + esc(term) + '”', 'Prueba con otra marca o línea, o revisa la ortografía.');
      if (box) box.innerHTML = statusHtml('', 'Buscando…', true);
      setFooter(root, false);
      var token = (root.__srsToken = (root.__srsToken || 0) + 1);
      var url = '/search/suggest.json?q=' + encodeURIComponent(term) +
        '&resources[type]=product&resources[limit]=' + limit +
        '&resources[options][unavailable_products]=hide';
      fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (token !== root.__srsToken) return;
          var suggested = (data && data.resources && data.resources.results && data.resources.results.products) || [];
          if (!suggested.length) {
            if (box) box.innerHTML = emptyHtml;
            return;
          }
          var handles = suggested.map(function (p) { return p.handle; }).filter(Boolean);
          Promise.all(handles.map(fetchProduct)).then(function (full) {
            if (token !== root.__srsToken) return;
            var valid = full.filter(function (p) { return p && p.available && p.variants && p.variants.length; });
            if (!valid.length) {
              if (box) box.innerHTML = emptyHtml;
              return;
            }
            renderResults(root, valid, term);
          });
        })
        .catch(function () {
          if (token !== root.__srsToken) return;
          if (box) box.innerHTML = statusHtml('No pudimos buscar ahora', 'Revisa tu conexión e inténtalo de nuevo.');
        });
    }

    function bindInstances() {
      document.querySelectorAll('sr-search-modal').forEach(function (root) {
        if (root.__srsBound) return;
        root.__srsBound = true;

        var input = root.querySelector('[data-srs-input]');
        var form = root.querySelector('[data-srs-form]');
        var dialog = root.querySelector('.srs__dialog');
        var clear = root.querySelector('[data-srs-clear]');
        var timer;

        fillTrending(root);

        function runInput() {
          var term = input.value.trim();
          if (clear) clear.hidden = !input.value;
          clearTimeout(timer);
          if (term.length < 2) { root.__srsToken = (root.__srsToken || 0) + 1; showTrending(root, true); return; }
          showTrending(root, false);
          timer = setTimeout(function () { doSearch(root, term); }, DEBOUNCE);
        }

        if (form) {
          form.addEventListener('submit', function (e) { if (!input || !input.value.trim()) e.preventDefault(); });
        }
        if (input) input.addEventListener('input', runInput);

        if (clear && input) {
          clear.addEventListener('click', function () {
            input.value = '';
            runInput();
            input.focus();
          });
        }

        root.querySelectorAll('[data-srs-chip]').forEach(function (chip) {
          chip.addEventListener('click', function () {
            if (!input) return;
            input.value = chip.getAttribute('data-srs-chip') || '';
            runInput();
            input.focus();
          });
        });

        root.querySelectorAll('[data-srs-close]').forEach(function (btn) { btn.addEventListener('click', closeModal); });
        if (dialog) {
          dialog.addEventListener('click', function (e) { if (e.target === dialog) closeModal(); });
          dialog.addEventListener('close', function () {
            clearTimeout(timer);
            root.__srsToken = (root.__srsToken || 0) + 1;
            if (input) input.value = '';
            if (clear) clear.hidden = true;
            var results = root.querySelector('[data-srs-results]');
            if (results) results.innerHTML = '';
            showTrending(root, true);
          });
        }
      });
    }

    bindInstances();
    document.addEventListener('DOMContentLoaded', bindInstances);
    document.addEventListener('shopify:cart:lines-update', function () { closeModal(); });
  })();

  } catch(e) { console.error(e); }
})();
})();
